import React, { Component } from 'react';
import cx from 'classnames';
import memoize from 'lodash.memoize';
import _omit from 'lodash.omit';
import isURL from 'validator/lib/isURL';
import memoizeOne from 'memoize-one';
import { Icon, FormModal, LabelWrapper, Button } from '../../../../../ui-kit';





import SocialInputs from './SocialInputs';

import '../styles/_link-social-button.scss';
import '../styles/_highlighted-icons.scss';





















const isValidURL = (value) => !value || isURL(value);

function getInitialState({ socialProfiles }) {
  const { website, facebook, twitter, linkedIn, other } = socialProfiles;

  return {
    website: { value: website || '', valid: isValidURL(website) },
    facebook: { value: facebook || '', valid: isValidURL(facebook) },
    twitter: { value: twitter || '', valid: isValidURL(twitter) },
    linkedIn: { value: linkedIn || '', valid: isValidURL(linkedIn) },
    other: { value: other || '', valid: isValidURL(other) }
  };
}

function getSocialProfilesFromState(
state,
allowedSocialTypes)
{
  return Object.keys(_omit(state, 'editingSocial')).
  reduce((socialProfiles, socialKey) => {
    if (allowedSocialTypes && !allowedSocialTypes.includes(socialKey)) {
      return socialProfiles;
    }

    return {
      ...socialProfiles,
      [socialKey]: state[socialKey].value
    };
  }, {});
}

export default class LinkSocialButton extends Component


{
  onUpdateField = memoize(
    (fieldName) => (evt) => {
      const { value } = evt.target;

      this.setState({
        [fieldName]: { value, valid: isValidURL(value) }
      });
    }
  );

  hasInvalidField = memoizeOne(
    (socialFields) => {
      // https://github.com/facebook/flow/issues/2221
      const fieldValues = Object.values(socialFields);

      return fieldValues.some((field) => !field.valid);
    }
  );

  static defaultProps = {
    socialProfiles: {},
    hideLabel: false,
    modalTitle: 'Link Social Profiles',
    buttonTitle: 'Link Social Profiles'
  };

  constructor(props) {
    super(props);

    this.state = {
      editingSocial: false,
      ...getInitialState(props)
    };
  }

  onSave = () => {
    const { onSave, allowedSocialTypes } = this.props;

    onSave(getSocialProfilesFromState(this.state, allowedSocialTypes));
  };

  getIcon = (name, { socialType }) => {
    const { allowedSocialTypes, socialProfiles } = this.props;

    if (allowedSocialTypes && allowedSocialTypes.length &&
    !allowedSocialTypes.some((type) => type === socialType)) {
      return null;
    }

    return (
      <Icon
        name={name}
        className={cx(
          'social-icon',
          `social-icon-${socialType.toLowerCase()}`,
          { 'social-icon--highlighted': socialProfiles[socialType] }
        )}
        color="white"
        size={17} />);


  };

  toggleModal = () => {
    const { socialProfiles } = this.props;

    this.setState(({ editingSocial }) => ({
      editingSocial: !editingSocial,
      ...getInitialState({ socialProfiles })
    }));
  };

  render() {
    const { editingSocial, ...draftSocialProfiles } = this.state;
    const {
      hideLabel,
      modalTitle,
      modalDescription,
      buttonTitle,
      allowedSocialTypes,
      disabled
    } = this.props;

    return (
      <>
      <FormModal
          key="social-inputs-modal"
          visible={editingSocial}
          onClose={this.toggleModal}
          title={modalTitle}
          subtitle={modalDescription}
          onSave={this.onSave}
          saveDisabled={this.hasInvalidField(draftSocialProfiles)}>

        <SocialInputs
            socialProfiles={draftSocialProfiles}
            onUpdateField={this.onUpdateField}
            allowedSocialTypes={allowedSocialTypes}
            isValidURL={isValidURL}
            disabled={disabled} />

      </FormModal>
      <LabelWrapper label={!hideLabel ? buttonTitle : void 0} notFullWidth className="link-social-button">
        <Button
            type="TERTIARY"
            className="link-social-button__button"
            onClick={this.toggleModal}
            key="link-social-button">

          <div className="link-social-button__button__icons">
            {this.getIcon('web', { socialType: 'website' })}
            {this.getIcon('facebook', { socialType: 'facebook' })}
            {this.getIcon('twitter', { socialType: 'twitter' })}
            {this.getIcon('linkedin', { socialType: 'linkedIn' })}
            {this.getIcon('options', { socialType: 'other' })}
          </div>
        </Button>
      </LabelWrapper>
    </>);

  }
}